import * as firebase from 'firebase';
require("firebase/firestore");

const prodConfig = {
    apiKey: "AIzaSyAdsPy2ucr-7jvcHz2C6GyDCtr2m5hi0mQ",
    authDomain: "sevenmiles-a22dc.firebaseapp.com",
    databaseURL: "https://sevenmiles-a22dc.firebaseio.com",
    projectId: "sevenmiles-a22dc",
    storageBucket: "sevenmiles-a22dc.appspot.com",
    messagingSenderId: "521783285084"
};

const devConfig = {
    apiKey: "AIzaSyAdsPy2ucr-7jvcHz2C6GyDCtr2m5hi0mQ",
    authDomain: "sevenmiles-a22dc.firebaseapp.com",
    databaseURL: "https://sevenmiles-a22dc.firebaseio.com",
    projectId: "sevenmiles-a22dc",
    storageBucket: "sevenmiles-a22dc.appspot.com",
    messagingSenderId: "521783285084"
};

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const fs = firebase.firestore();

// const settings = {timestampsInSnapshots: true};
// fs.settings(settings);

const auth = firebase.auth();

export {
  db,
  fs,
  auth,
};


// WEBPACK FOOTER //
// ./src/Firebase/firebase.js